import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const HypervergeFailurePopUp = (props) => {
    return (
        <Modal isOpen={props.hypervergeFailure} style={{ borderBottom: "none", padding: "10px"}} centered>
            <ModalHeader toggle={props.toggleHypervergeFailure} style={{ borderBottom: "none", padding: "10px"}}></ModalHeader>
            <ModalBody className="succ-body">
                <div className='wrapper text-center m-3'>
                    <h5 style={{color: "#000000", fontSize: "30px"}}>Congratulations!</h5>
                    <p className="text-2 offline-popup-small">Thank you for sharing your details. 
                    Your details will be verified within 24 - 48 working hours.
                    </p>
                    <img className="mt-3 text-center m-auto" style={{ width: "35%" }} src={" https://assets.biddeasy.com/HyperVerge/like-1%20(1).webp"} alt="result-icon" />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default HypervergeFailurePopUp;